<template>
  <div>
    <v-container>
      <v-row>
        <v-col
          v-for="(course, index) in courses"
          :key="index"
          class="align-center d-flex justify-center textDown"
          v-on:click="courseInfo(course, (dialog = true))"
        >
          <div class="text-uppercase text-center ma-2">
            {{ course.name }}
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="text-h6 text-center justify-center text-uppercase hyphenation">
          {{ selectedCourse.name }}
        </v-card-title>

        <v-card-text class="pa-4">
          {{ selectedCourse.intro }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="main" text @click="dialog = false"> Закрыть </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import courses from "../courses/courses";
import { gsap } from "gsap";

export default {
  name: "Courses",

  data: () => ({
    courses: courses,
    dialog: false,
    selectedCourse: {},
  }),
  methods: {
    courseInfo: function (course) {
      this.selectedCourse = course;
    },
  },
  computed: {
    ...mapGetters(["IS_MOBILE", "IS_DESKTOP"]),
  },
  mounted() {
    gsap.from(".textDown", {
      scrollTrigger: {
        trigger: ".textDown",
        start: "top bottom-=200px",
        once: true,
        toggleActions: "restart none none pause",
      },
      y: -30,
      opacity: 0,
      duration: 2,
    });
  },
};
</script>

<style lang="scss" scoped>
.col {
  div {
    cursor: pointer;
    &:hover {
      color: #ff8049;
    }
  }
}
.hyphenation{
 word-break: keep-all;
}
</style>

